module.exports = __webpack_public_path__ + "img/Magisk.fb74e50e.png";